<template>
  <div class="detail-dialog">
    <v-dialog
      v-show="detailDialog"
      v-model="detailDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline grey darken-4 white--text">
          <span class="headline">{{ currentStudio.title.value }}</span>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="setDetailDialog(false)">Close</v-btn>
        </v-card-title>
        <v-row justify="center" class="studio-thumbnail">
          <div v-viewer.rebuild="{inline: true}">
            <img :src="currentStudio.thumbnail" />
          </div>
        </v-row>
        <v-row dense justify="end">
          <!-- Change thumbnail -->
          <v-col cols="4">
            <v-btn
              color="success"
              class="text-none"
              small
              :loading="isUploading"
              :disabled="isUploading"
              @click="selectFile"
            >
              <v-icon>mdi-image</v-icon>
              Change thumbnail...
            </v-btn>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".jpg,.jpeg,.png"
              @change="uploadThumbnail"
            />
          </v-col>
        </v-row>
        <v-card-text class="pb-0">
          <v-row v-if="irregularExtension" dense justify="end">
            <span class="error--text">
              You can only upload ".jpg", ".jpeg", or ".png" file.
            </span>
          </v-row>
        </v-card-text>
        <v-card-text class="pb-0 pt-2">
          <v-row justify="end" class="subtitle-2">
            <span>Created at: {{ currentStudio.createdAt }}</span>
            <span class="pl-4">
              Last updated: {{ currentStudio.updatedAt }}
            </span>
          </v-row>
          <v-row justify="end" class="caption">
            <span>ID: {{ currentStudio.id }}</span>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'detailDialog',
  components: {},
  props: {
    detailDialog: {
      type: Boolean,
      default: false,
    },
    currentStudio: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isUploading: false,
      selectedFile: null,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    irregularExtension: function() {
      return (
        this.selectedFile &&
        !this.selectedFile.type.match('image/jpeg') &&
        !this.selectedFile.type.match('image/png')
      )
    },
  },
  methods: {
    setDetailDialog(show) {
      this.$emit('setDetailDialog', show)
    },
    async refresh(optionName) {
      switch (optionName) {
        case 'thumbnail':
          const image = await this.getStudioThumbnailById(this.currentStudio.id)
          if (!image) {
            return
          }
          this.currentStudio[optionName] = image
          this.isUploading = false
          break

        default:
          this.currentStudio[optionName].value = this.currentStudio[
            optionName
          ].dispValue
          break
      }
    },
    selectFile() {
      this.selectedFile = null
      window.addEventListener('focus', () => {}, {once: true})

      this.$refs.uploader.click()
    },
    async uploadThumbnail(e) {
      this.selectedFile = e.target.files[0]

      if (this.irregularExtension) {
        return
      }

      this.isUploading = true
      const result = await this.setStudioThumbnailById(
        this.currentStudio.id,
        this.selectedFile
      )
      if (!result) {
        this.isUploading = false
        return
      }
      await this.refresh('thumbnail')
    },
  },
  mounted() {},
}
</script>

<style lang="scss">
.studio-thumbnail {
  width: 100%;
  height: 220px;
  margin: auto;
  & > div {
    & > img {
      display: none;
    }
    &.viewer-backdrop {
      background-color: rgb(0, 0, 0);
    }
    .viewer-one-to-one,
    .viewer-navbar,
    .viewer-prev,
    .viewer-play,
    .viewer-next,
    .viewer-rotate-left,
    .viewer-rotate-right,
    .viewer-flip-horizontal,
    .viewer-flip-vertical {
      display: none;
    }
    .viewer-zoom-out {
      float: right;
    }
    &:last-of-type {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>

<style scoped>
.v-form > div {
  align-items: center;
}
.v-select {
  margin-top: 0;
  padding-top: 0;
}
.v-chip--disabled {
  opacity: 1;
}
</style>
